import React, { Component } from "react";
import { debounce } from 'throttle-debounce';
import * as Autosuggest from 'react-autosuggest';
import { Errors } from 'react-redux-form';
import { Form, FloatingLabel } from 'react-bootstrap';

import './custom-form.component.css'

export class InputAutoSuggest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ""
            , suggestions: []
            , isFetching: true
            , rawOptions: []
            , withIcon: props.withIcon
            , onChangeReset: false
            , haveError: false
        };

        this.autocompleteSearchDebounced = debounce(500, this.autocompleteSearch);
    }

    componentDidMount = () => {
        const { defaultValue } = this.props;
        this.setState({
            value: this.props.value
        })
        if (defaultValue) {

            this.onChange(null, { newValue: defaultValue });
            this.onChangeSuggestion(null, { newValue: defaultValue });
        }
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value, this.props.options)
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    getSuggestions = (value, arrObj) => {
        const escapedValue = this.escapeRegexCharacters(value.trim());

        if (escapedValue === '' || !arrObj) {
            return [];
        }

        var suggestions = arrObj.map(a => a[this.props.propDisplay]);

        return suggestions?.filter(suggestion => suggestion?.toLowerCase()?.includes(value?.toLowerCase()));
    };
    //.includes(value.toLowerCase())
    escapeRegexCharacters = str => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    onSuggestionSelected = (event, { suggestion }) => {
        const { propDisplay, onChangeAction } = this.props;
        this.setState({
            value: suggestion
        });

        if (onChangeAction) {
            onChangeAction(suggestion, propDisplay, this.state.rawOptions);
        }
    };

    getSuggestionValue = suggestion => {
        this.setState({ haveError: false })
        return suggestion.Name;
    };

    renderSuggestion = suggestion => {
        return <span className="auto-suggest-form-item">{suggestion}</span>
    };

    handleOnblurAction = () => {
        const { value, errorMessage } = this.props;
        if (errorMessage) {
            if (!value) {
                this.setState({ haveError: true })
            } else {
                this.setState({ haveError: false })
            }
        }
    }

    renderInputComponent = inputProps => {
        const { label, fieldProp } = this.props;
        const {value}= this.state;
        const handleInputChange = e => {
            if (e.target.value.length <= 100) {
                inputProps.onChange(e);
                this.setState({ onChangeReset: true })
            }
        };

        return (
            <div>
                {
                    (fieldProp && value) && <Errors model={fieldProp} className="has-error" />
                }
                <input
                    className={`react-autosuggest__input`}
                    onClick={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                    {...inputProps}
                    onChange={handleInputChange}
                    placeholder={this.props.placeholder}
                    onBlur={this.handleOnblurAction}
                />
                {
                    (fieldProp && value) &&
                    <Errors
                        className="control-errors required"
                        model={fieldProp}
                    />
                }
            </div>
        );
    }

    onChangeSuggestion = (event, { newValue }) => {

        this.setState({ value: newValue }, () => {
            this.autocompleteSearchDebounced(this.state.value);
        });
    };

    autocompleteSearch = val => {
        this._fetch(val);
    };

    _fetch = async val => {
        const { onChangeClear, onChangeAction, searchAction, propDisplay, defaultValue } = this.props;
        const { onChangeReset } = this.state;
        val = val.trim();

        if (val === '' && !onChangeClear) {

            if (onChangeAction) {
                onChangeAction(val);
            }
            return;
        }

        if (onChangeReset) {
            if (onChangeAction) {
                onChangeAction(val);
            }
        }

        this.setState({ isFetching: false, onChangeReset: false });

        var res = await searchAction(val, propDisplay);
        if (res != null) {

            this.setState({
                rawOptions: res,
            });

            res = res.length > 0 ? res.map(a => a[propDisplay]) : '';
            res = res.slice(0, 10);

            this.setState({
                suggestions: res
            });

            this.setState({ isFetching: true });

            if (defaultValue == val) {
                this.onSuggestionSelected(null, { suggestion: defaultValue });
            }
        } else {
            this.setState({ isFetching: true });
        }
    };

    render() {
        const { hidden, disabled, maxLength, placeholder, label, required } = this.props;
        const { value, suggestions, isFetching } = this.state;

        const inputProps = {
            placeholder: placeholder,
            value: value !== undefined ? value : '',
            onChange: this.onChangeSuggestion,
            hidden: hidden,
            disabled: disabled,
            maxLength: maxLength,
        };
        return (
            <Form.Group hidden={hidden} className="auto-suggest-form">
                <FloatingLabel controlId={label} label={label} className={required ? "required" : ""}>
                    <Autosuggest
                        //id={this.props.id}
                        suggestions={isFetching ? suggestions : []}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        onSuggestionSelected={this.onSuggestionSelected}
                        getSuggestionValue={this.getSuggestionValue}
                        renderInputComponent={this.renderInputComponent}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={inputProps}
                    />
                </FloatingLabel>
            </Form.Group>
        )
    }
}